import React,{ useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { UserApi } from "../app/api/user.api";
import { RepositoryApi } from "../app/api/repository.api";
// import { userService } from "../api/user.service";
// import { RepositoryService } from "../api/repository.service";


export function ContainerRightImg( { img, title, text } ){
    return(
        <div className="row py-5">
            <div className="col-md-5 d-flex flex-column align-items-center justify-content-center px-4">
                <p className="font-xxl text-muted bold text-center"> { title } </p>
                <p className="font-lg text-muted text-center"> { text } </p>
            </div>
            <div className="col-md-2 mb-4"></div>
            <div className="col-md-5">
                <div className="d-flex align-items-center justify-content-center">
                   <img className="" height={'300px'} src={ img } alt="left-image" />
                </div>
            </div>
        </div>
    )
}

export function ContainerLeftImg( { img, title, text } ){
    return(
        <div className="row py-5">         
            <div className="col-md-5">
                <div className="d-flex align-items-center justify-content-center">
                   <img className="" height={'300px'} src={ img } alt="left-image" />
                </div>
            </div>
            <div className="col-md-2 mb-4"></div>
            <div className="col-md-5 d-flex flex-column align-items-center justify-content-center px-4">
                <p className="font-xxl color-light bold text-center"> { title } </p>
                <p className="font-lg color-light text-center"> { text } </p>
            </div>
        </div>
    )
}


/************************************* IMAGE CONTAINER ****************************************** */

export function CardH({ icon, value, title })
{
    return(
        <div className="d-flex align-items-center justify-content-center border p-3">  
            <i className= {`fs-1 text-light ${ icon }`} ></i>
            <div className="d-flex flex-column ms-3">
                <span className="h5 mb-1 color-light"> + { value } </span> 
                <span className="color-light">  { title }  </span>
            </div>
        </div>
    )
}

export function CardImgCenter({ img, subTitle, title, text, link, btnText })
{
    return(
        <div className="d-flex border rounded-2 p-1"> 
            <div className="d-flex flex-column border rounded-2 bg-light p-4 w-100"> 
                <span className="text-muted text-lead mb-1"> { subTitle } </span>
                <span className="h3 color-green mb-2"> { title } </span>
                <img className='rounded-4 mb-3' src={ img } height={'200px'} alt="" /> 
                <p className="text-muted text-lead"> { text } </p>
                <div className='d-flex'>
                    <a href={ link } className="link btn btn-sm btn-orange-outline rounded-5 px-3"> { btnText } </a> 
                </div>
            </div>
        </div>
    )
}

export function ImgCardmD( { img, title, text='' } ){
    return(
        <div className="border rounded-3 d-flex flex-column align-items-center p-4">
            <img className="" height={'60px'} width={'60px'} src={ img } alt="" />
            <span className="text-muted text-center mt-2 px-3"> { text } </span>
        </div>
    )
}

export function ImgCard( { img, title } ){
    return(
        <div className="d-flex align-items-center gap-2 bg-light shadow-sm p-4 rounded-3">
            <img src={img} className="" height={'40px'}  alt="" />
            <span className="font-lg text-muted"> {title} </span>
        </div>
    )
}

export function ImgCardLg( { img, text } )
{
    return(
        <div className="d-flex align-items-center border p-3">
            <img src={img} alt="" className="me-3" height="60px" />
            <span className="text-muted"> {text} </span>
        </div>
    )
}


/************************************* MODAL****************************************** */

export function ModelMobile( { close } ){

    return(
       
       <div className="setting-model shadow">
            <div className="d-flex flex-column w-100 bg-green-light rounded-3">
                <div className="d-flex justify-content-between align-items-center p-3">
                    <span className='text-muted font-sm' > Téléchargement... </span>
                    <span className='cursor color-orange border-orange rounded-circle px-2' onClick={ ()=>{ close() } } > X </span>
                </div> 
                <div className="d-flex flex-column w-100 px-3 mb-3 border-top pt-3"> 
                    <span className='font-xs text-muted mb-1 text-center'> Support Android </span>
                    <a href='/' className='link btn btn-greenD-outline px-4'> Télécharger maintenant </a>
                </div>
                <div className="d-flex flex-column w-100 px-3 py-2 mb-3 border-top"> 
                    <span className='font-xs text-muted mb-1 text-center'> Support Ios </span>
                    <a href='/' className='link btn btn-greenD-outline px-4'> Télécharger maintenant </a>
                </div>
            </div>
        </div> 
    )
}

export function ModelSoftware( { close } ){

    return(
       
       <div className="setting-model-2 shadow">
            <div className="d-flex flex-column w-100 bg-orange-light rounded-3">
                <div className="d-flex justify-content-between align-items-center p-3">
                    <span className='text-muted font-sm' > Téléchargement... </span>
                    <span className='cursor color-orange border-orange rounded-circle px-2' onClick={ ()=>{ close() } } > X </span>
                </div> 
                <div className="d-flex flex-column w-100 px-3 mb-3 border-top pt-3"> 
                    <span className='font-xs text-muted mb-1 text-center'> OS window </span>
                    <a href='/' className='link btn btn-orange-outline px-4'> Télécharger maintenant </a>
                </div>
                <div className="d-flex flex-column w-100 px-3 py-2 mb-3 border-top"> 
                    <span className='font-xs text-muted mb-1 text-center'> OS Ubuntu </span>
                    <a href='/' className='link btn btn-orange-outline px-4'> Télécharger maintenant </a>
                </div>
            </div>
        </div> 
    )
}





export function DocModal({close, onSubmit, onChange, filename, text})
{
    return(
        <div className="row doc-model d-flex justify-content-center align-items-center px-4">
            <form className="col-lg-5 col-md-8 shadow bg-white rounded-4 border p-0" onSubmit={onSubmit}> 
                <div className="d-flex border-bottom px-4 py-3">  
                    <span className="text-muted font-md"> {text} </span>     
                </div>
                <div className="d-flex flex-column border-bottom px-4 py-3 mt-2">  
                    <label htmlFor="file-picker" className="cursor mb-3 d-flex flex-column align-items-center justify-content-center bg-light p-4 rounded-3 border-dashed w-100" >
                        <img className="" height={'50px'} width={'50px'} src={'../../img/icons8-3.png'} alt="left-image" /> 
                        <span className="text-muted font-xs"> {filename} </span>
                    </label> 
                    <input name="file" type="file" className="hidden" id="file-picker" onChange={ onChange } />
                    <div className="d-flex flex-column mb-3">
                        <label htmlFor="input1" className="font-xs text-muted mb-1"> Choisir cycle universitaire (<span className="color-orange"> obligatoire</span>) </label>
                        <select className="form-select border-main text-muted font-sm" name="label" id="input1" onChange={onChange} required>
                            <option value=""> Choisir le niveau universitaire </option>
                            <option value="Licence"> Licence </option>
                            <option value="Master"> Master </option>
                            <option value="Doctorat"> Doctorat </option>
                            <option value="Autres"> Autres </option>
                        </select>
                    </div>
                    <div className="d-flex flex-column mb-4">
                        <label htmlFor="input2" className="font-xs text-muted"> Description (<span className="color-orange"> optionelle </span>) </label>
                        <textarea className="form-control text-muted font-sm" name="description" id="input2" rows="4" onChange={onChange}></textarea>
                    </div>
                </div>
                <div className="d-flex justify-content-between px-4 py-3">  
                    <button className="btn btn-sm btn-orange-outline font-sm" onClick={ close } > Annuler </button>
                    <button className="btn btn-sm btn-green font-sm" type="submit"> Enregistrer </button>
                </div>
            </form>
        </div>
    )
}



export function ShareModal({close, text, save, repid })
{
   
    const repInstance = RepositoryApi();


// ************************************************************

    const [response , setResponse] = useState(false);
    const [message , setMessage] = useState('');

    const [inputs, setInputs] = useState({
      link: false,
      access: "",
    });

    
    const handleInputs = (e) => {
      const { name, value, type, checked } = e.target;
      setInputs((prev) => ({
        ...prev,
        [name]: type === "checkbox" ? checked : value,
      }));
    };

    
    // const handleForm = async ( event ) => {
    //     event.preventDefault()
    //     setResponse(false)
    //     const data = {
    //         acces : inputs.acces,
    //         link : inputs.link,
    //         users : selectedUsers
    //     }

    //     console.log(data);

    //     repInstance.sendNotification(repid, data)
    //     .then( res => {
    //         if( res.message === true ) save()
    //         else{ 
    //             setMessage('Oops ! une erreur est survenue. Veuillez réessayer') 
    //             setResponse(true)
    //         }
    //     } )
    //     .catch( err => {
    //         setMessage('Erreur serveur interne. Veuillez réessayer') 
    //         setResponse(true)
    //     } )
    // } 


    const handleForm = async (e) => {
       e.preventDefault();

       const payload = {
          repositoryId: repid,
          access: inputs.access,
          users: selectedUsers.map(u => u.id),
          generateLink: inputs.link
       };

       console.log(payload);

       try {
         const {data} = await repInstance.share(payload);
         if (data.success){
            save();
         } 
         else{ 
            setMessage('Oops ! une erreur est survenue. Veuillez réessayer') 
            setResponse(true)
         }
       } catch (err) {
         setMessage("Erreur serveur interne");
         setResponse(true);
       }
    };


// ************************************************************

    const user = UserApi();
            
    const findUsers = async () => {
        const {data} = await user.findAll();
        return data.data;
    };
                 
    const { data } = useQuery({
        queryKey: ["users"],
        queryFn: findUsers
    });

    const [query, setQuery] = useState("");
    const [filteredUsers, setFilteredUsers] = useState([]);
    const [selectedUsers, setSelectedUsers] = useState([]);

    const handleInputChange = (e) => {
        const value = e.target.value;
        setQuery(value);
        const filtered = data.filter(
          (user) =>
            user.email.toLowerCase().startsWith(value.toLowerCase()) &&
            !selectedUsers.find((u) => u.id === user.id)
        );
        setFilteredUsers(filtered);
    };
    
    const handleUserClick = (user) => {
        setSelectedUsers([...selectedUsers, user]);
        setQuery("");
        setFilteredUsers([]);
    };
    
    const removeUser = (userId) => {
        setSelectedUsers(selectedUsers.filter((u) => u.id !== userId));
    };

// ************************************************************

    return(
        <div className="row doc-model d-flex justify-content-center align-items-center px-4">
            <form className="col-lg-5 col-md-8 shadow bg-white rounded-4 border p-0" onSubmit={ handleForm } > 
                <div className="d-flex border-bottom px-4 py-3">  
                    <span className="text-muted font-md"> {text} </span>     
                </div>
                <div className="d-flex flex-column border-bottom px-4 py-2 mt-2">  
                    {
                        response ? ( <div className="alert text-center alert-danger"> <span className="text-muted"> { message } </span> </div> ) : null
                    }
                    <div className="d-flex">
                        <input type="text" name="search" value={query} className="p-2 form-control" placeholder="chercher mail utilisateur..." onChange={handleInputChange} />        
                    </div>
                    {
                        filteredUsers.length > 0 && (
                            <ul className="scroll-md list-container">
                                {filteredUsers.map((item) => (
                                    <li className="list-item" key={item.id} onClick={() => handleUserClick(item)}>
                                        <div className="d-flex align-items-center justify-content-start">  
                                            <img src="../img/icons8-student-64.png" className="" alt="" width="25" />
                                            <div className="d-flex flex-column">
                                                <span className="font-xs text-muted"> { item.username } </span>
                                                <span className="font-xs color-orange"> { item.email } </span> 
                                            </div>
                                        </div> 
                                    </li>
                                ))}
                            </ul>
                        )
                    }

                    <span className="text-muted font-sm mb-1 mt-2 ps-1"> Utilisateurs avec accès </span>

                    <ul className="scroll-xs list-container mb-2 scroll-xs py-3 px-2">
                        {selectedUsers.map((item) => (
                            <li key={item.id}>
                                <div className="d-flex align-items-center justify-content-between py-1 px-2 border rounded-2 mb-2">  
                                    <div className="d-flex align-items-center justify-content-start gap-2">  
                                        <img src="../img/icons8-student-64.png" className="" alt="" width="25" />
                                        <div className="d-flex flex-column">
                                            <span className="font-xs text-muted"> { item.username } </span>
                                            <span className="font-xs color-orange"> { item.email } </span> 
                                        </div>
                                    </div>
                                    <button className="btn btn-sm font-xs bg-danger text-white" onClick={() => removeUser( item.id )}> X </button>
                                </div> 
                            </li>
                        ))}
                    </ul>
                </div>
                <div className="d-flex flex-column border-bottom px-4 py-3">  
                    <div className="d-flex mb-1 gap-2">
                        <input type="checkbox"  checked={ inputs.link }  name="link" className="" placeholder="search" onChange={handleInputs} />        
                        <span className="text-muted font-sm"> Générer un lien de partage </span>
                    </div>
                    <span className="color-orange font-xs"> Une fois coché, tous les utilisateurs qui disposent de ce lien pourront exploiter ce répertoire </span>
                </div>
                <div className="d-flex justify-content-between align-items-center border-bottom px-4 py-3">
                    <span className="text-muted font-sm"> Droit d'accès </span>
                    <select name="access" className="border-none font-sm text-muted px-2" onChange={handleInputs} required >
                        <option value=""> choisir droit d'acces </option>
                        <option value="read"> Lecteur </option>
                        <option value="write"> Editeur </option>
                    </select>
                </div>
                <div className="d-flex justify-content-between px-4 py-3">  
                    <button className="btn btn-sm btn-orange-outline font-sm" onClick={ close } > Annuler </button>
                    <button className="btn btn-sm btn-green font-sm" type="submit" > Enregistrer </button>
                </div>
            </form>
        </div>
    )
}


/************************************* DOCUMENT CONTAINER ****************************************** */

export function Doc({ name, date, path })
{
    const baseURL = process.env.REACT_APP_API_URL

    return(
        <div className="d-flex flex-column border mb-4">
            <div className="d-flex align-items-center border-bottom py-2">
                <div className="d-flex justify-content-center align-items-center"> <img src="../img/icons8-file.png" alt="" className="me-1" width="50px" /> </div>
                <div className="d-flex flex-column"> 
                    <span className="tex-muted font-sm mb-1"> { name } </span> 
                    <span className="font-xs color-orange"> { date } </span> 
                </div>
            </div>
            <div className="d-flex align-items-center px-2 py-3 gap-2">
                <a href={ baseURL + path } className="btn btn-sm btn-light-outline"> ouvrir </a>
                <a href={ baseURL + path } download className="btn btn-sm btn-light-outline"> telecharger </a>
            </div>
        </div>
    )
}

export function DocFrame({ name, date, path })
{
    const baseURL = process.env.REACT_APP_API_URL

    return(
        <div className="d-flex flex-column border bg-white mb-4 rounded-3">
            <div className="d-flex align-items-center border-bottom py-2">
                <div className="d-flex justify-content-center align-items-center"> <img src="../../img/icons8-file.png" alt="" className="me-1" width="42px" /> </div>
                <div className="d-flex flex-column"> 
                    <span className="tex-muted font-sm mb-1"> { name } </span> 
                    <span className="font-xs color-orange"> { date } </span> 
                </div>
            </div>
            <div className="d-flex align-items-center px-2 py-3 gap-2">
                <a href={ baseURL + path } className="btn btn-sm btn-light-outline"> Ouvrir </a>
                <a href={ baseURL + path } download className="btn btn-sm btn-light-outline"> Telecharger </a>
            </div>
        </div>
    )
}


/************************************* VIDEO FRAMES ****************************************** */

export function VideoFrame({ link, text, date })
{
    return(
        <div className="d-flex flex-column mb-5">
            <div className="d-flex video-frame mb-2"> 
                <iframe width={'100%'} src={link} title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
            </div>
            <div className="d-flex flex-column p-2 border">
                <span className=" font-sm text-muted mb-2"> < TextReducer text={ text } maxsize={100} />  </span>
                <span className="font-xs color-orange"> { date } </span> 
            </div>
        </div>
    )
}

export function TextReducer({text, maxsize}) 
{
    if ( text.length <= maxsize ) return ( <span > { text }  </span> )
    else{
        const reducer = text.slice(0, maxsize) + '...';
        return ( <span > { reducer }  </span> )
    }
}


/* **************************************** REPOSITORY ************************************************** */

export function RepositoryFrame({ name, date, id, isShared, owner, src, extra=false })
{
    return(

<div className="card rounded border mb-3">
  <div className="d-flex flex-column">
        
       {
            extra && (
                <div className="d-flex px-3 py-2 border-bottom gap-2">
                    <span className="text-muted"> De : </span>
                   <img src={ src } className="rounded-circle me-1" alt="" width={25} height={25} />
                   <span className="text-secondary"> {owner} </span>
                </div>
             )
        }

      <div className="card-body d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center gap-3">
        {/* LEFT */}
        <div className="d-flex align-items-start gap-3">
          <div className="bg-light py-2 px-3 d-flex align-items-center justify-content-center border rounded">
            <i className="bi bi-folder-fill fs-4 text-warning"></i>
          </div>

          <div className="d-flex flex-column">
            <div className="d-flex align-items-center gap-2">
              <span className="fw-semibold text-muted">{name}</span>

              {/* SHARE STATUS */}
              {
                isShared && (
                   <span className="badge bg-success-subtle text-success border border-success-subtle px-1">
                     <i className="bi bi-link-45deg"></i>
                   </span>
                ) 
              }
            </div>
            
            <small className="text-secondary fs-sm mt-1">
              <i className="bi bi-calendar3 me-1 small"></i>
              Créé le {date}
            </small>
          </div>
        </div>

        {/* RIGHT */}
        <div className="w-md-auto text-end">
          <a
            href={`/rep/${id}`}
            className="btn btn-sm btn-green-outline px-3"
          >
            <i className="bi bi-box-arrow-up-right me-1"></i>
            Ouvrir
          </a>
        </div>
      </div>

  </div>
</div>

    )
}




export function RepoFrame({ name, date, id, isShared })
{
    return(

    <div className="card rounded border mb-3">

      <div className="d-flex flex-column b">
      
        <div className="d-flex align-items-start justify-content-between gap-3 w-100 border-bottom p-2">
          <div className="bg-light py-1 px-2 d-flex align-items-center justify-content-center border rounded">
            <i className="bi bi-folder-fill fs-6 text-warning"></i>
          </div>
          <div className="d-flex border">
            <a href={`/rep/${id}`} className="btn btn-sm btn-green-outline px-3" >
               <i className="bi bi-box-arrow-up-right me-1"></i> Ouvrir
            </a>
          </div>
        </div>

        <div className="d-flex flex-column p-2">
            <div className="d-flex align-items-center gap-2">
              <span className="fw-semibold text-muted">{name}</span>
              {
                isShared && (
                   <span className="badge bg-success-subtle text-success border border-success-subtle px-1">
                     <i className="bi bi-link-45deg"></i>
                   </span>
                ) 
              }
            </div>
            <small className="text-secondary fs-sm mt-1">
              <i className="bi bi-calendar3 me-1 small"></i>
              Créé le {date}
            </small>
        </div> 

      </div>

    </div>


    )
}



export function RepositoryFramePlus({ name, date, id, openModal, state, isShared })
{
    return(

        <div className="card rounded border mb-4 shadow-sm">
            <div className="card-body d-flex gap-3">

                {/* LEFT */}
                <div className="d-flex align-items-start gap-3">
                  <div className="bg-light py-2 px-3 d-flex align-items-center justify-content-center border rounded">
                    <i className="bi bi-folder-fill fs-4 text-warning"></i>
                  </div>

                  <div className="d-flex flex-column">
                    <div className="d-flex align-items-center gap-2">
                      <span className="fw-semibold text-muted">{name}</span>

                      {/* SHARE STATUS */}
                      {
                        isShared && (
                           <span className="badge bg-success-subtle text-success border border-success-subtle px-1">
                             <i className="bi bi-link-45deg"></i>
                           </span>
                        ) 
                      }
                    </div>

                    <small className="text-secondary fs-sm mt-1">
                      <i className="bi bi-calendar3 me-1 small"></i>
                      Créé le {date}
                    </small>
                  </div>
                </div>
            </div>
            <div className="card-footer border-top py-2 px-3 d-flex gap-2">
                <a href={`/rep/${id}`} className="btn btn-sm btn-green-outline px-2" title="Ouvrir">
                   <i className="bi bi-box-arrow-up-right me-1"></i> 
                </a>
                <button className="btn btn-sm btn-green-outline px-2" title="Partager" onClick={ openModal } > 
                   <i className="bi bi-people me-1"></i>  
                </button>
                <a href={`/parametre/${id}`} className="btn btn-sm btn-orange-outline px-2" title="Paramètre"> 
                   <i className="bi bi-sliders me-1"></i>
                </a>
            </div>
       </div>
    )
}



export function SharedRepFrame({ name, date, isShared, owner, src, extra=false, token })
{
    return(

<div className="card rounded border mb-3">
  <div className="d-flex flex-column">
        
       {
            extra && (
                <div className="d-flex px-3 py-2 border-bottom gap-2">
                    <span className="text-muted"> De : </span>
                   <img src={ src } className="rounded-circle me-1" alt="" width={25} height={25} />
                   <span className="text-secondary"> {owner} </span>
                </div>
             )
        }

      <div className="card-body d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center gap-3">
        {/* LEFT */}
        <div className="d-flex align-items-start gap-3">
          <div className="bg-light py-2 px-3 d-flex align-items-center justify-content-center border rounded">
            <i className="bi bi-folder-fill fs-4 text-warning"></i>
          </div>

          <div className="d-flex flex-column">
            <div className="d-flex align-items-center gap-2">
              <span className="fw-semibold text-muted">{name}</span>

              {/* SHARE STATUS */}
              {
                isShared && (
                   <span className="badge bg-success-subtle text-success border border-success-subtle px-1">
                     <i className="bi bi-link-45deg"></i>
                   </span>
                ) 
              }
            </div>
            
            <small className="text-secondary fs-sm mt-1">
              <i className="bi bi-calendar3 me-1 small"></i>
              Créé le {date}
            </small>
          </div>
        </div>

        {/* RIGHT */}
        <div className="w-md-auto text-end">
          <a
            href={`/shared/${token}`}
            className="btn btn-sm btn-green-outline px-3"
          >
            <i className="bi bi-box-arrow-up-right me-1"></i>
            Ouvrir
          </a>
        </div>
      </div>

  </div>
</div>

    )
}



export function RepositoryItems({link, title})
{
    return(
        <a href={link} className="link"><div className="d-flex flex-column align-items-center p-3 border mb-4">
            <img src="../img/icons8-folder-94.png" alt="" width="100" />
            <span className="text-muted"> {title} </span>
        </div></a>
    )
}


/* ****************************************** NOTIFICATION CONTAINER ************************************************* */

export function NotifFrame({ message })
{
    return(
        <div className="d-flex flex-column shadow-sm border bg-white gap-2 py-3 px-4 rounded-1 mb-3">
            <div className="d-flex align-items-center gap-2 mt-1">
                <span className="text-muted bg-green-light py-1 px-3 border rounded-1 font-md"> Message  </span> 
                <span className="text-muted "> { message } </span> 
            </div>     
        </div> 
    )
}


